import * as React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';

/**
 * Senviro toast surface — wraps Sonner's `<Toaster>` with theme-aware
 * defaults and the design tokens defined in W1-F7-S3.
 *
 * Usage:
 *   import { Toaster, toast } from '@/components/ui/toast';
 *   <Toaster />               // mount once at the app shell root
 *   toast.success('Saved!');  // anywhere in the tree
 */
export const Toaster: React.FC<React.ComponentProps<typeof SonnerToaster>> = (
  props,
) => {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { toast };
